import { useEffect, useState } from 'react'

type MobileLandscapeOverlayState = {
  isTouchViewport: boolean
  useLandscapeOverlay: boolean
  shouldRotateOverlay: boolean
}

export default function useMobileLandscapeOverlay(): MobileLandscapeOverlayState {
  const [state, setState] = useState<MobileLandscapeOverlayState>({
    isTouchViewport: false,
    useLandscapeOverlay: false,
    shouldRotateOverlay: false,
  })

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }

    const mediaQuery = window.matchMedia('(max-width: 1023px) and (hover: none), (max-width: 1023px) and (pointer: coarse)')

    const syncState = () => {
      const isPortraitViewport = window.innerHeight > window.innerWidth
      const isTouchViewport = mediaQuery.matches

      setState({
        isTouchViewport,
        useLandscapeOverlay: isTouchViewport,
        shouldRotateOverlay: isTouchViewport && isPortraitViewport,
      })
    }

    syncState()

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', syncState)
    } else {
      mediaQuery.addListener(syncState)
    }

    window.addEventListener('resize', syncState)
    window.addEventListener('orientationchange', syncState)

    return () => {
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', syncState)
      } else {
        mediaQuery.removeListener(syncState)
      }

      window.removeEventListener('resize', syncState)
      window.removeEventListener('orientationchange', syncState)
    }
  }, [])

  return state
}
